import React, { useState } from 'react';

const StatusSelection = ({
    status,
    handleStatusChange,
  }) => {

    return (
        <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-6 flex-wrap">
            <button type="button" onClick={() => handleStatusChange('All')} className={`px-2 py-2 font-semibold justify-content-center ${status === 'All' ? 'bg-grey' : 'bg-grey-lightest'} rounded-lg mr-2 hover:bg-grey`}>
                All Status
            </button>
            <button type="button" onClick={() => handleStatusChange('Active')} className={`px-2 py-2 font-semibold justify-content-center ${status === 'Active' ? 'bg-grey' : 'bg-grey-lightest'} rounded-lg mr-2 hover:bg-grey`}>
                Active
            </button>
            <button type="button" onClick={() => handleStatusChange('Unconfirmed')} className={`px-2 py-2 font-semibold justify-content-center ${status === 'Unconfirmed' ? 'bg-grey' : 'bg-grey-lightest'} rounded-lg mr-2 hover:bg-grey`}>
                Unconfirmed
            </button>
            <button type="button" onClick={() => handleStatusChange('Pending')} className={`px-2 py-2 font-semibold justify-content-center ${status === 'Pending' ? 'bg-grey' : 'bg-grey-lightest'} rounded-lg mr-2 hover:bg-grey`}>
                Pending
            </button>
            {/* <button type="button" onClick={() => handleStatusChange('Duplicate')} className={`px-2 py-2 font-semibold justify-content-center ${status === 'Duplicate' ? 'bg-grey' : 'bg-grey-lightest'} rounded-lg mr-2 hover:bg-grey`}>
                Duplicate
            </button> */}
            <button type="button" onClick={() => handleStatusChange('Stuck >48h')} className={`px-2 py-2 font-semibold justify-content-center ${status === 'Stuck >48h' ? 'bg-grey' : 'bg-grey-lightest'} rounded-lg mr-2 hover:bg-grey`}>
                Stuck >48h
            </button>
            <button type="button" onClick={() => handleStatusChange('Expiring soon')} className={`px-2 py-2 font-semibold justify-content-center ${status === 'Expiring soon' ? 'bg-grey' : 'bg-grey-lightest'} rounded-lg mr-2 hover:bg-grey`}>
                Expiring soon
            </button>
            <button type="button" onClick={() => handleStatusChange('Expired')} className={`px-2 py-2 font-semibold justify-content-center ${status === 'Expired' ? 'bg-grey' : 'bg-grey-lightest'} rounded-lg mr-2 hover:bg-grey`}>
                Expired
            </button>
            </div>
        </div>
    );
};

export default StatusSelection;